/**
 * @author yly
 * @description 释放坐席
 * @Date 2023/09/07
 */

import { utils_tool } from '@/tool';
const { Storage } = utils_tool;

const seatsOut = ({ fun }) => {
  window.addEventListener('popstate', function () {
    if (Storage.getStorage('locCno')) {
      fun({ cno: Storage.getStorage('locCno') })
      Storage.removeStorage('locCno');
    }
  })
}

export { seatsOut }
